<template>
  <VuePopper
    trigger="click"
    :visible-arrow="false"
    :options="{
      placement: 'bottom',
    }"
  >
    <div class="popover vue-popover time_span fade in">
      <div class="popover-content location-tracking-options-container">
        <ul class="list-group location-tracking-options-group">
          <a
            :data-value="JOB_SITE_RECORD.trackingTime"
            href="#"
            class="list-group-item location-tracking-options-group-item"
            @click="updateWithPassiveLocationTrackingOn"
          >
            While tracking
          </a>
          <a
            v-if="passiveDuringShiftEnabled"
            :data-value="JOB_SITE_RECORD.alsoDuringShifts"
            href="#"
            class="list-group-item location-tracking-options-group-item"
            @click="updateWithPassiveLocationTrackingOn"
          >
            While tracking and during shifts
          </a>
          <a
            :data-value="JOB_SITE_RECORD.always"
            href="#"
            class="list-group-item location-tracking-options-group-item"
            @click="updateWithPassiveLocationTrackingOn"
          >
            Always
          </a>
        </ul>
      </div>
    </div>
    <!-- capturing the click event in order to prevent the default action, then emitting it again so that the popover is displayed -->
    <template #reference>
      <a
        class="enable-location-settings"
        href="#"
        @click.prevent="$emit('click')"
      >
        Enable their location settings.
      </a>
    </template>
  </VuePopper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { JOB_SITE_RECORD } from '../../app_constants';

export default {
  name: 'ClientLocationSettingOptions',
  props: {
    members: Array,
  },
  emits: ['click', 'remove-member'],
  data() {
    return {
      JOB_SITE_RECORD,
    };
  },
  computed: {
    ...mapGetters(['passiveDuringShiftEnabled']),
  },
  methods: {
    ...mapActions(['updateLocationTrackingSetting']),
    updateWithPassiveLocationTrackingOn(event) {
      event.preventDefault();
      const payload = Object.assign({}, this.getPayload(), { settingValue: event.target.getAttribute('data-value') });

      this.sendRequest(payload);
    },
    updateWithPassiveLocationTrackingOff(event) {
      event.preventDefault();
      const payload = Object.assign({}, this.getPayload(), { settingValue: JOB_SITE_RECORD.trackingTime });

      this.sendRequest(payload);
    },
    sendRequest(payload) {
      return this.updateLocationTrackingSetting(payload)
        .then((members) => {
          this.$emit('remove-member', members);
          this.$appMessage('Location setting(s) updated');
        })
        .catch((response) => {
          this.$appMessage(response.error);
        });
    },
    getPayload() {
      return {
        users: this.members,
        settingName: 'location_tracking',
      };
    },
  },
};
</script>
